import "../helpers/TextInput.css";
import { useState } from "react";
import { CharacterLimitIndicator } from "../helpers/CharacterLimitIndicator"

export function TextInput({
  CharacterLimit = 0,
  SupportingText = "",
  Placeholder = "",
  OnChange,
  Disabled = false,
  Value = null,
}) {
  const [characterLimitLabel, setCharacterLimitLabel] = useState(
    "Character Limit 0/" + CharacterLimit
  );
  const [characterLimitStatus, setCharacterLimitStatus] = useState("");

  const handleChange = (event) => {
    var str = event.target.value.toString();
    OnChange(str);
    handleCharacterLimit(str.length);
  };

  const handleCharacterLimit = (inputLength) => {
    if (inputLength > CharacterLimit) {
      setCharacterLimitStatus(" invalid");
    } else {
      setCharacterLimitStatus("");
    }
    setCharacterLimitLabel(
      "Character Limit " + inputLength + "/" + CharacterLimit
    );
  };

  return (
    <div className="autoMargin">
      <input
        disabled={Disabled}
        onChange={handleChange}
        className="form-control textInput"
        type="text"
        defaultValue={Value}
        placeholder={Placeholder}
        aria-label={Placeholder}
      />
      {CharacterLimit > 0 && (
        <div className={"supportingText" + characterLimitStatus}>
          {/*{characterLimitLabel}*/}
          <CharacterLimitIndicator maxChars={CharacterLimit} inputStr={Value} />
        </div>
      )}
      
      {SupportingText && <div className="supportingText">{SupportingText}</div>}
    </div>
  );
}
